/**
 * Futura parts store shell: header and footer behaviour.
 *
 * No framework, no dependencies on Dawn's JS. Dawn's own search modal and cart
 * notification keep their own scripts; nothing here touches them.
 */
(function () {
  'use strict';

  var hoverable = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  /* ---------------------------------------------------- Contact dropdown --
     The nav is flat now, so this matches nothing. It is kept because the day
     something does need a menu, the two fixes below are the ones that took a
     round to find: hover and click must never both toggle, and closing has to
     be delayed or a diagonal towards the panel shuts it on the way. */
  var HOVER_GRACE = 240;

  document.querySelectorAll('[data-fx-drop]').forEach(function (item) {
    var btn = item.querySelector('.fx-nav__link');
    if (!btn) return;

    var timer = null;

    function set(open) {
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function hold() {
      if (timer) { window.clearTimeout(timer); timer = null; }
    }
    function open() { hold(); set(true); }
    function closeNow() { hold(); set(false); }
    function closeSoon() {
      hold();
      timer = window.setTimeout(function () { timer = null; set(false); }, HOVER_GRACE);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!hoverable) set(!item.classList.contains('is-open'));
    });
    btn.addEventListener('focus', open);

    if (hoverable) {
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', closeSoon);
      item.addEventListener('click', function (e) {
        if (e.target.closest('.fx-drop a')) closeNow();
      });
    }

    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) closeNow();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNow();
    });
  });

  /* ------------------------------------------------------- Mobile panel -- */
  function panelFor(el) {
    var shell = el.closest('.fx-shell');
    return shell ? shell.querySelector('.fx-panel') : null;
  }
  function setPanel(panel, open) {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    var shell = panel.closest('.fx-shell');
    if (!shell) return;
    shell.querySelectorAll('[data-fx-burger]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  function closePanels() {
    document.querySelectorAll('.fx-panel.is-open').forEach(function (p) { setPanel(p, false); });
  }
  document.querySelectorAll('[data-fx-burger]').forEach(function (b) {
    b.addEventListener('click', function () {
      var panel = panelFor(b);
      if (!panel) return;
      setPanel(panel, !panel.classList.contains('is-open'));
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanels();
  });

  document.querySelectorAll('[data-fx-macc] > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var li = b.parentElement;
      var open = !li.classList.contains('is-open');
      li.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ------------------------------------------------------- Support sheet --
     Support is a page now. This is here for any surface still opening a sheet;
     the HubSpot embed script is fetched on first open and never again. */
  var hsLoading = false;

  function loadHubspot(sheet) {
    var mount = sheet.querySelector('[data-fx-support-mount]');
    var fallback = sheet.querySelector('[data-fx-support-fallback]');
    var portal = sheet.getAttribute('data-portal');
    var form = sheet.getAttribute('data-form');

    if (!mount || mount.getAttribute('data-ready') === '1') return;
    if (!portal || !form) {
      if (fallback) fallback.hidden = false;
      return;
    }
    if (!mount.id) mount.id = 'fxSupportMount-' + Math.random().toString(36).slice(2);
    mount.setAttribute('data-ready', '1');

    function create() {
      if (!window.hbspt || !window.hbspt.forms) {
        mount.setAttribute('data-ready', '');
        if (fallback) fallback.hidden = false;
        return;
      }
      window.hbspt.forms.create({
        portalId: portal,
        formId: form,
        region: 'na1',
        target: '#' + mount.id
      });
    }

    if (window.hbspt && window.hbspt.forms) { create(); return; }
    if (hsLoading) return;
    hsLoading = true;

    var s = document.createElement('script');
    s.src = 'https://js.hsforms.net/forms/embed/v2.js';
    s.async = true;
    s.onload = create;
    s.onerror = function () {
      mount.setAttribute('data-ready', '');
      if (fallback) fallback.hidden = false;
    };
    document.head.appendChild(s);
  }

  function sheetFor(el) {
    var shell = el.closest('.fx-shell');
    var local = shell ? shell.querySelector('[data-fx-sheet]') : null;
    return local || document.querySelector('[data-fx-sheet]');
  }

  document.querySelectorAll('[data-fx-support]').forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      var sheet = sheetFor(t);
      if (!sheet) return;
      closePanels();
      document.querySelectorAll('.fx-nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
      sheet.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      loadHubspot(sheet);
    });
  });

  function closeSheets() {
    document.querySelectorAll('[data-fx-sheet].is-open').forEach(function (s) { s.classList.remove('is-open'); });
    if (!document.querySelector('.fx-panel.is-open')) document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-fx-sheet-close]').forEach(function (c) {
    c.addEventListener('click', closeSheets);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });

  /* ---------------------------------------------------------- VIN button --
     THE BUTTON OPENS THE TRAILER, NOT THE SEARCH. It used to scroll to the top
     of the VIN block, which is the one place a customer who already has a
     trailer does not need to go: it showed them an empty VIN field and asked
     them to do the thing they had already done.

     The extension exposes getVinSearchModal(), and the instance has
     openWithVin(), which is exactly the VIN Matched view with the trailer
     loaded. That covers anyone who searched by VIN.

     For a model pick there is no equivalent entry point, and there does not
     need to be: the pick bar still holds that range, model and year, and its
     own Find Parts button is the path the extension already supports. Clicking
     it for them lands on the same filtered results.

     Everything is guarded. If the modal handle is missing, if the method is
     gone after an extension deploy, or if nothing is stored, the click is left
     alone and the href does what it always did. */
  function readKey(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function stampOf(rec) {
    var t = rec && rec.timestamp ? Date.parse(rec.timestamp) : NaN;
    return isNaN(t) ? 0 : t;
  }

  function openWithVin(vin) {
    try {
      var modal = window.getVinSearchModal && window.getVinSearchModal();
      if (!modal || typeof modal.openWithVin !== 'function') return false;
      modal.openWithVin(vin);
      return true;
    } catch (e) { return false; }
  }

  function openByModel() {
    var find = document.querySelector('[data-ident-find]');
    if (!find) return false;
    find.click();
    return true;
  }

  function openTrailer() {
    var vinRec = readKey('lastSearchedTrailer');
    var pickRec = readKey('fxTrailerPick');
    var vin = vinRec && String(vinRec.vinNumber || '').trim();
    var picked = pickRec && String(pickRec.modelName || '').trim();

    // Newest wins, the same rule the button's label already follows, so what
    // it says and what it opens can never disagree.
    var vinFirst = vin && (!picked || stampOf(vinRec) >= stampOf(pickRec));

    if (vinFirst && openWithVin(vin)) return true;
    if (picked && openByModel()) return true;
    if (vin && openWithVin(vin)) return true;
    return false;
  }

  function newestIsPick() {
    var vinRec = readKey('lastSearchedTrailer');
    var pickRec = readKey('fxTrailerPick');
    var vin = vinRec && String(vinRec.vinNumber || '').trim();
    var picked = pickRec && String(pickRec.modelName || '').trim();
    return !!picked && (!vin || stampOf(pickRec) > stampOf(vinRec));
  }

  document.querySelectorAll('[data-fx-vin]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var home = a.getAttribute('data-fx-vin-home') || '/';
      var here = window.location.pathname.replace(/\/$/, '') || '/';
      var target = home.split('?')[0].replace(/\/$/, '') || '/';

      // Somewhere else on the store. A model pick lands on the VIN page as
      // before, where the extension brings back that pick's results. Anything
      // else asks the extension for the VIN search with ?vin_open: the matched
      // view when a VIN is on file, the empty VIN tab when not. Without it the
      // extension reopened whatever the modal last showed, which could be the
      // Model & year tab. An extension without ?vin_open support ignores it.
      if (here !== target) {
        if (newestIsPick()) return;
        e.preventDefault();
        window.location.assign(home + (home.indexOf('?') === -1 ? '?' : '&') + 'vin_open=1');
        return;
      }

      closePanels();

      if (openTrailer()) { e.preventDefault(); return; }

      // Nothing stored, or the handle has gone: the old behaviour, which at
      // least puts them in front of the search.
      var block = document.querySelector('vin-search-modal, .shopify-app-block');
      if (!block) return;
      e.preventDefault();
      block.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* -------------------------------------------------------- Search Parts --
     Opens the extension's Search by part name tab, exactly as the "Part Name"
     link under the home page VIN box does (getVinSearchModal().open('part')).

     Where the VIN block is on the page the modal is right here, so it opens in
     place and the menu closes behind it. Anywhere else there is no modal, and
     the link's own href goes to the VIN page with ?vin_open=part, which the
     extension reads on load. Guarded like the VIN button: no handle, no modal
     element or an exception, and the href does what it says. A modified click
     (new tab) is left to the browser. */
  function openPartSearch() {
    try {
      var modal = window.getVinSearchModal && window.getVinSearchModal();
      if (!modal || !modal.modalElement || typeof modal.open !== 'function') return false;
      modal.open('part');
      return true;
    } catch (e) { return false; }
  }

  document.querySelectorAll('[data-fx-parts]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      closePanels();
      if (openPartSearch()) e.preventDefault();
    });
  });
})();
